import { Div, TableBuilder, Link, Collection, RefNumber, RefString, TextInput, NumberInput, RefDate, Pie } from "@tblabs/truffle";
import { Icons } from "../Components/Utils/Icons";
import { XPrimaryButton } from "../Components/Utils/XPrimaryButton";
import { AgentsProvider } from "../Services/AgentsProvider";
import { AuthService } from "../Services/Auth/AuthService";
import { Router } from "../Services/Router";
import { FatalError } from "../Components/FatalError";
import { PrimaryButton } from "../Components/Utils/PrimaryButton";
import { DangerButton } from "../Components/Utils/DangerButton";


export class AgentsPage extends Div
{
    constructor(private _router: Router, private _auth: AuthService, private _agents: AgentsProvider)
    {
        super();

        if (!_auth.UserInfo?.Permissions?.CanSeeAgents)
        {
            this.Append(new FatalError("Nie masz uprawnień do oglądania tej strony"));
            return;
        }

        this.Append(
            new TableBuilder(this._agents.All)
                .AddColumn("Icon", x => x.Icon)
                .AddColumn("Imię", x => x.Name + (x.IsActive ? "" : " (nieaktywny)"))
                .AddColumn("Telefon", x => x.Phone)
                .AddColumn("", x => new XPrimaryButton("Zadania", Icons.Calendar, () => this._router.GoToAgentTasks(x.Id)))
                .AddColumn("", x => new Link("😴 Dezaktywuj").OnClick(() => x.IsActive = false))
                .Build()
        );
    }
}

export class MagazineItem
{
    public Name = new RefString();
    public NewAmount = new RefNumber();
    public IncomingAmount = new RefNumber();
    public InServiceAmount = new RefNumber();
    public InUseAmount = new RefNumber();
    public ReadyAmount = new RefNumber();
    public BrokenAmount = new RefNumber();
    public UpdatedAt = new RefDate();
    public RequiredAmount = new RefNumber();

    constructor(raw?: Partial<RawMagazineItem>)
    {
        this.Name.value = raw?.Name || "";
        this.NewAmount.value = raw?.NewAmount || 0;
        this.IncomingAmount.value = raw?.IncomingAmount || 0;
        this.InServiceAmount.value = raw?.InServiceAmount || 0;
        this.InUseAmount.value = raw?.InUseAmount || 0;
        this.ReadyAmount.value = raw?.ReadyAmount || 0;
        this.BrokenAmount.value = raw?.BrokenAmount || 0;
        this.UpdatedAt.value = new Date(raw?.UpdatedAt || 0);
        this.RequiredAmount.value = raw?.RequiredAmount || 0;
    }

    public ToRaw(): RawMagazineItem
    {
        return {
            Name: this.Name.value,
            NewAmount: this.NewAmount.value,
            IncomingAmount: this.IncomingAmount.value,
            InServiceAmount: this.InServiceAmount.value,
            InUseAmount: this.InUseAmount.value,
            ReadyAmount: this.ReadyAmount.value,
            BrokenAmount: this.BrokenAmount.value,
            UpdatedAt: this.UpdatedAt.value,
            RequiredAmount: this.RequiredAmount.value,
        };
    }
}

export class Magazine
{
    public Items = new Collection<MagazineItem>();
}

export interface RawMagazineItem
{
    Name: string;
    NewAmount: number;
    IncomingAmount: number;
    InServiceAmount: number;
    InUseAmount: number;
    ReadyAmount: number;
    BrokenAmount: number;
    RequiredAmount: number;
    UpdatedAt: Date;
}
export class MagazinePage extends Div
{
    constructor(private _router: Router, private _auth: AuthService, private _magazine: Magazine)
    {
        super();

        const storage = window.localStorage.getItem("magazine");
        const items = JSON.parse(storage || "[]");
        for (const item of items as RawMagazineItem[])
        {
            this._magazine.Items.Add(new MagazineItem(item));
        }

        this.Append(
            new TableBuilder(this._magazine.Items).Class("uk-table-small uk-table-striped")
                .AddColumn("Przedmiot", x => new TextInput(x.Name))
                .AddColumn("Nowe", x => new NumberInput(x.NewAmount))
                .AddColumn("Zamówione", x => new NumberInput(x.IncomingAmount))
                .AddColumn("W serwisie", x => new NumberInput(x.InServiceAmount))
                .AddColumn("W użyciu", x => new NumberInput(x.InUseAmount))
                .AddColumn("Gotowe", x => new NumberInput(x.ReadyAmount))
                .AddColumn("Zepsute", x => new NumberInput(x.BrokenAmount))
                .AddColumn("Wymagana ilość", x => [new NumberInput(x.RequiredAmount), new Pie(x.RequiredAmount)])
                .AddColumn("Opcje", x => new Link("🗑️ Usuń").OnClick(() => this._magazine.Items.Remove(x)))
                .Build(),
            new PrimaryButton("➕ Dodaj", () => this._magazine.Items.Add(new MagazineItem())),
            new DangerButton("Zapisz", () =>
            {
                window.localStorage.setItem("magazine", JSON.stringify(this._magazine.Items.Items.map(x => x.ToRaw())));
            }).MarginLeft(8),
        );
    }
}